import React from 'react';
import { Button } from '@/components/ui/button';
import { Pencil, Trash2, ExternalLink } from 'lucide-react';
import { LoadingSpinner, EmptyState } from './shared';

export const ProductsSection = ({ products, loading, onEdit, onDelete }) => (
  <div className="space-y-4" data-testid="admin-products">
    {loading ? <LoadingSpinner /> : products.length > 0 ? (
      <div className="bg-white rounded-lg shadow-sm overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="text-left p-4 font-semibold text-gray-600">Produkt</th>
              <th className="text-left p-4 font-semibold text-gray-600 hidden md:table-cell">Butik</th>
              <th className="text-left p-4 font-semibold text-gray-600">Pris</th>
              <th className="text-right p-4 font-semibold text-gray-600">Åtgärder</th>
            </tr>
          </thead>
          <tbody>
            {products.slice(0, 50).map((product) => (
              <tr key={product.id} className="border-t hover:bg-gray-50">
                <td className="p-4">
                  <a href={`/produkt/${product.id}`} className="flex items-center gap-3 hover:text-[#003B73]">
                    <div className="w-10 h-10 bg-gray-100 rounded overflow-hidden flex-shrink-0">
                      {product.images?.[0] && <img src={product.images[0]} alt="" className="w-full h-full object-cover" />}
                    </div>
                    <span className="font-medium line-clamp-1">{product.title}</span>
                  </a>
                </td>
                <td className="p-4 text-sm text-gray-600 hidden md:table-cell">{product.store_name}</td>
                <td className="p-4 font-semibold">{product.price?.toLocaleString('sv-SE')} kr</td>
                <td className="p-4 text-right">
                  <div className="flex justify-end gap-2">
                    <Button variant="ghost" size="sm" onClick={() => onEdit(product)} title="Redigera">
                      <Pencil className="h-4 w-4" />
                    </Button>
                    <Button variant="ghost" size="sm" className="text-red-500 hover:text-red-700" onClick={() => onDelete(product)} title="Ta bort">
                      <Trash2 className="h-4 w-4" />
                    </Button>
                    <a href={`/produkt/${product.id}`} target="_blank" rel="noopener noreferrer">
                      <Button variant="ghost" size="sm" title="Visa annons">
                        <ExternalLink className="h-4 w-4" />
                      </Button>
                    </a>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : <EmptyState message="Inga produkter" />}
  </div>
);
